import React, { useEffect, useMemo } from 'react';
import { LoginButton } from '@appcharge/shared-ui';
import {
  ELoginMethods,
  ESessionStorageKeys,
  EButtonVariant,
  EPublisherWebhookEventTypeV2,
  ELoginEventsV2,
} from '../../../constants/enums';
import { useTranslation } from 'react-i18next';
import { useLoginPage } from '../useLoginPage.hook';
import useUrlHash from 'hooks/useUrlHash';
import { useLoginState } from 'state/hooks/login.state.hook';
import { webStorageUtil } from 'state/webStorage.state.service';
import useLoginEvents from 'hooks/useLoginEvents';

export const FacebookLogin: React.FC = () => {
  const { publisherMetaData } = useLoginPage();
  const { sendPublisherWebhookLoginEventV2 } = useLoginEvents();
  const { hasConsent, loginResponse, loginButtonClickWrapper } = useLoginState();
  const facebookAccessToken = useUrlHash('#access_token');
  const appId = publisherMetaData.integration.playersAuthentication.fbAppId;
  const isLoginCanceled = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return (
      urlParams.get('state') === 'facebookredirect' &&
      urlParams.get('error_reason') === 'user_denied'
    );
  }, []);
  const { t } = useTranslation();

  useEffect(() => {
    if (isLoginCanceled) {
      webStorageUtil.remove(ESessionStorageKeys.REDIRECT_STATE);
      sendPublisherWebhookLoginEventV2({
        eventName: ELoginEventsV2.WEBSTORE_LOGIN_CANCELED,
        eventType: EPublisherWebhookEventTypeV2.PRE_LOGIN,
        method: ELoginMethods.FACEBOOK,
      });
    }
  }, [isLoginCanceled]);

  useEffect(() => {
    if (facebookAccessToken) facebookResponseHandler();
  }, [facebookAccessToken]);

  const facebookResponseHandler = () => {
    const data = {
      userToken: facebookAccessToken || undefined,
      authMethod: ELoginMethods.FACEBOOK,
    };
    webStorageUtil.remove(ESessionStorageKeys.REDIRECT_STATE);
    loginResponse(data);
  };

  const loginClickHandler = async () => {
    window.location.href = `https://www.facebook.com/v17.0/dialog/oauth?response_type=token&client_id=${appId}&redirect_uri=${window.location.origin}${window.location.pathname}&state=facebookredirect`;
  };

  const facebookButtonVariant = publisherMetaData.storeTheme.login.facebookButton?.variant;
  const buttonVariant = useMemo(
    () => (facebookButtonVariant === EButtonVariant.OUTLINED ? 'facebookOutlined' : 'facebook'),
    [facebookButtonVariant]
  );

  return (
    <LoginButton
      variant={buttonVariant}
      callback={() => loginButtonClickWrapper(loginClickHandler, ELoginMethods.FACEBOOK)}
      text={t('login.signInWithFacebook')}
      dataTestId="facebook-login-button"
      isDisabled={!hasConsent}
      opacityOnDisabled={false}
    >
      <img src="https://media.appcharge.com/defaults/facebook_icon_white.svg" alt="facebook icon" />
    </LoginButton>
  );
};
